import { Injectable } from '@angular/core';
import { UserSettings } from 'src/app/models/user-settings';
import { StorageService } from './storage.service';

const userSettingsKey = 'USER_SETTINGS';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  public defaultDateFormat = 'yyyy-MM-dd';
  public defaultDecimalFormat = '1-2.2';
  public defaultCsvFormat = ';-,';

  constructor(private storageService: StorageService) {
    if (!this.get()) {''
      let defaultUserSettings: UserSettings = {
        dateFormat: this.defaultDateFormat,
        decimalFormat: this.defaultDecimalFormat,
        csvFormat: this.defaultCsvFormat
      };
      this.update(defaultUserSettings);
    }
  }

  update(userSettings: UserSettings) {
    this.storageService.setLocalStorageItem(
      userSettingsKey,
      JSON.stringify(userSettings)
    );
  }

  get(): UserSettings {
    return JSON.parse(this.storageService.getLocalStorageItem(userSettingsKey));
  }
  getCsvFormat():string[] {
    let data = JSON.parse(this.storageService.getLocalStorageItem(userSettingsKey));
    if (!data.csvFormat) return this.defaultCsvFormat.split('-');
    return data.csvFormat.split('-');
  }
}